import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 350px;
`;

export const ListContainer = styled.div`
  flex: 1;
  overflow: auto;
  margin-top: 20px;
`;

export const ButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 30px;
`;
